module.exports = __webpack_public_path__ + "static/media/item_5_8_comp.f31932ab.png";